"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundMultiLineSelectField = BoundMultiLineSelectField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const inputs_1 = require("../inputs");
const utils_1 = require("../utils");
const defaultLabel_1 = require("../utils/defaultLabel");
const useTestIds_1 = require("../utils/useTestIds");
function BoundMultiLineSelectField(props) {
    const { field, options, readOnly, getOptionValue = (opt) => opt.id, // if unset, assume O implements HasId
    getOptionLabel = (opt) => opt.name, // if unset, assume O implements HasName
    onSelect = (value) => field.set(value), label = (0, defaultLabel_1.defaultLabel)(field.key), onBlur, onFocus, ...others } = props;
    const testId = (0, useTestIds_1.useTestIds)(props, field.key);
    return ((0, jsx_runtime_1.jsx)(mobx_react_1.Observer, { children: () => {
            var _a;
            return ((0, jsx_runtime_1.jsx)(inputs_1.MultiLineSelectField, { label: label, values: (_a = field.value) !== null && _a !== void 0 ? _a : [], onSelect: (values, options) => {
                    onSelect(values, options);
                    field.maybeAutoSave();
                }, options: options, readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : field.readOnly, errorMsg: field.touched ? field.errors.join(" ") : undefined, required: field.required, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, onBlur: () => {
                    field.blur();
                    (0, utils_1.maybeCall)(onBlur);
                }, onFocus: () => {
                    field.focus();
                    (0, utils_1.maybeCall)(onFocus);
                }, ...others, ...testId }));
        } }));
}
